import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { API, ApiKeyDTO } from '../../../../services/api/api';
import { ErrorService } from '../../../../services/error.service';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { SbDateTime } from '../../../../services/api/api-date-time';
import { ModalService } from '../../../../services/gui/modal/modal.service';

@Component({
  selector: 'sb-page-api-key-edit',
  templateUrl: './api-key-edit.component.html',
  styleUrls: ['./api-key-edit.component.scss'],
  standalone: false,
})
export class ApiKeyEditComponent implements OnInit {
  modalService = inject(ModalService);

  @Input({ required: true }) apiKey: ApiKeyDTO;

  @Output() apiKeyChanged: EventEmitter<ApiKeyDTO>;
  loading: boolean;
  expires: SbDateTime | null;
  apiKeyString: string;

  form: UntypedFormGroup;

  get Name() {
    return this.form.get('Name');
  }

  constructor(
    private readonly api: API,
    private readonly errorHandler: ErrorService
  ) {
    this.apiKeyString = '';
    this.expires = null;
    this.form = new UntypedFormGroup({
      Name: new FormControl<string>(null),
    });
    this.loading = true;
    this.apiKeyChanged = new EventEmitter<ApiKeyDTO>();
  }

  ngOnInit(): void {
    this.registerFormChangesListener();

    if (this.apiKey) {
      this.updateForm();
    } else {
      this.apiKey = new ApiKeyDTO();
    }
    this.loading = false;
  }

  private registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      this.apiKey.name = value === '' || value?.trim() === '' ? null : value;
    });
  }

  updateForm() {
    this.Name.setValue(this.apiKey.name);
    this.Name.markAsTouched();
  }

  createOrEditApiKey() {
    if (!this.apiKey.identifier) {
      this.api.ca_am_ApiKey_create(this.apiKey).subscribe({
        next: data => {
          this.apiKey = data.reference;
          this.apiKeyString = data.apiKey;
          this.modalService
            .modal(
              {
                title: 'Api Key',
                modalOptions: { windowClass: 'sm' },
              },
              {
                templateId: 'ApiKeyModal',
              }
            )
            .then(() => {})
            .catch(() => {})
            .finally(() => {
              this.apiKeyChanged.emit(this.apiKey);
            });
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    } else {
      this.api.ca_am_ApiKey_edit(this.apiKey.identifier, this.apiKey).subscribe({
        next: data => {
          this.apiKey = data;
          this.apiKeyChanged.emit(this.apiKey);
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    }
  }
}
